<template>
  <div class="u-header">
    <div
      class="u-header-menu"
      @click="onMenuClick"
      v-click-outside="clickOutside"
    >
      <img src="../../assets/main/menu@2x.png" alt="" />
    </div>
    <div class="u-header-logo">
      <img src="../../assets/logo@2x.png" alt="" />
      <span>优服管理系统</span>
    </div>
    <div class="u-header-bar">
      <!-- <project-list /> -->
      <!--TODO 未开始-->
      <!--<message></message>-->
      <!--<user-set></user-set>-->
      <user></user>
    </div>
  </div>
</template>

<script>
import user from "./user";
import userSet from "./user-set";
import message from "./message";
// import projectList from "./project-list";
import { directive as clickOutside } from "v-click-outside-x";
export default {
  name: "header",
  directives: {
    clickOutside
  },
  methods: {
    onMenuClick() {
      // console.log("onmenuclick");
      this.$emit("on-menu-click");
    },
    clickOutside() {
      this.$emit("on-menu-outside-click");
    }
  },
  components: {
    user,
    userSet,
    message,
    // projectList
  }
};
</script>
